import './LoadingCover.sass';

import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { Spin } from 'antd';

const spinIcon = <CircularProgress className="ts-loading-icon-mui" />;

const LoadingCover = () => (
	<div className="ts-loading-shading-mui">
		<Spin indicator={spinIcon} tip="Loading..." size="large" />
	</div>
);

export default LoadingCover;
